<template>
  <div class="not-found" :style="style">
    <span class="emoji">😕</span>
    <span class="text">找不到資料</span>
  </div>
</template>

<script>
export default {
  props: {
    absolute: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    style() {
      return {
        'position': this.absolute ? 'absolute' : 'relative',
        'width': this.absolute ? '100%' : 'auto',
        'height': this.absolute ? '100%' : 'auto'
      };
    }
  }
};
</script>

<style lang="stylus" scoped>
.not-found {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding:2rem;
}

.emoji {
  font-size: 3rem;
}

.text {
  font-size: 1.5rem
  padding: 1rem;
  margin-top: 0.5rem;
}
</style>